import { connect } from "react-redux";
import BlindSpotShrink from "./BlindSpotShrink";


// Shares the getSelfVsOthers trend response with What moved most — this
// section reads its `data` rows, that one the category movement lists.
const mapStateToProps = (state) => ({
    fetchTrendSelfVsOthersApi: state.BenchmarkFilteringReducer.fetchTrendSelfVsOthersApi

});

const mapDispatchToProps = (dispatch) => ({

});


export default connect(mapStateToProps, mapDispatchToProps)(BlindSpotShrink);
